/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import { Row, Col } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
/* Components */
import { ReactComponent as TrashIcon } from '../../../../resources/images/trash-icon.svg';
import UCButton from "../../../buttons";

/* Styles */
import styles from "../styles";

const AuthorisedSkeleton = () => {
  const theme = useTheme();
  const classes = styles({ theme });

  const returnContent = () => {
    let inputs = [0,1,2]
    return(
      inputs.map((item, id) => (        
        <div className={classes.wrapper} key={id}>
          <div className={classes.inputContainer}>
            <label className={`${classes.label} ${id !== 0  ? classes.hideLabel : ""}`}>
              <FormattedMessage id="inviteauthorisedmodal.name"/>
            </label>
            <div className={classes.label}>
              <Skeleton
                width={200}
                height={36}
                count={1}
                className={classes.headerSk1}
              />
            </div>                                      
          </div>
          <div className={classes.inputWrapper}>
            <div className={classes.inputAndBtnContainer}>
              <label className={`${classes.label} ${id !== 0  ? classes.hideLabel : ""}`}>
                <FormattedMessage id="inviteauthorisedmodal.email"/>
              </label>
              <div className={classes.label}>
                <Skeleton
                  width={"100%"}
                  height={36}
                  count={1}
                  className={classes.headerSk1}
                />
              </div> 
            </div>
            <UCButton
              className={`${classes.deleteBtn} ${id === 0  ? classes.firstBtn : ""} ${classes.disableBtn}`}
              type="default"
              icon={<TrashIcon />}
              disabled={true}
            />
          </div>
        </div>
      ))
    )
  }

  return (
    <div className={classes.modalContent}>
      <Row className={classes.scrollableContainer}>
        {returnContent()}        
      </Row>
      <div className={classes.btnContainer}>
        <Col className={classes.colRemove} >
          <UCButton
            className={classes.createBtn}
            type="primary"
            text={<FormattedMessage id="inviteauthorisedmodal.invite"/>}
            disabled={true}
          />
        </Col>
      </div>
    </div>
  );
};

export default AuthorisedSkeleton;
